<template>
  <div v-if="marketRecommendData.length > 0" class="other-recommend">
    <div class="other-recommend-title">推薦商品</div>
    <Carousel
      class="recommend-slider recommend-slide"
      :items-to-show="1.25"
      :snap-align="'center'"
      :wrap-around="true"
      :breakpoints="breakpoints"
      @slide-start="slideStart"
      @slide-end="slideEnd"
    >
      <Slide v-for="item in marketRecommendData" :key="item.url">
        <div class="item-box">
          <div class="inner">
            <div class="item-img-box">
              <a :href="item.url">
                <NewImage :url="item.image" :size="'_w851_h1129'" :name="item.name" />
              </a>
            </div>
            <div class="item-info">
              <div class="item-name text-center">
                <a :href="item.url">{{ item.name }}</a>
              </div>
              <div class="item-price text-center">
                <span
                  v-if="item.sellPrice !== item.originPrice || item.eventPrice > 0"
                  class="mr-2 origin-price"
                >
                  NT.{{ item.originPrice.toLocaleString('en-US') }}
                </span>
                <span
                  class="sell-price"
                  :class="{
                    mark: item.eventPrice > 0 || item.sellPrice < item.originPrice,
                  }"
                >
                  NT.{{
                    item.eventPrice > 0 && item.eventPrice < item.sellPrice
                      ? item.eventPrice
                      : item.sellPrice
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Slide>
    </Carousel>
  </div>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia';

import useShopContentStore from '@global/stores/useShopContentStore';

import { Carousel, Slide } from 'vue3-carousel';
import NewImage from '@global/components/common/Image/NewImage.vue';

import {
  fireRecommendByCategoryClickEvent,
  fireRecommendViewGAEventByCategory,
} from '@global/gtm/product';

const nowSlide = ref(false);
const breakpoints = ref({
  992: {
    itemsToShow: 4,
    snapAlign: 'start',
  },
});

const shopContentStore = useShopContentStore();
const { marketRecommendData, marketRecommendIsLoad, selectedFoodSpec, itemDatas } =
  storeToRefs(shopContentStore);
const { getMarketRecommendData } = shopContentStore;

watch(marketRecommendIsLoad, (nV) => {
  if (nV && marketRecommendData.value.length) {
    fireRecommendViewGAEventByCategory({
      itemListName: `${window.CustomMarketID.split('SZ')[0]} 用戶推薦產品列表`,
      recommendData: marketRecommendData.value,
    });
  }
});

function slideStart(direction) {
  nowSlide.value = true;
  fireRecommendByCategoryClickEvent({
    recommendedType: '產品內頁',
    recommendedMove:
      direction.currentSlideIndex < direction.slidingToIndex
        ? '推薦商品 More 左滑'
        : '推薦商品 More 右滑',
    itemListName: '品牌推薦產品列表',
    recommendedData: marketRecommendData.value,
    productId: window.CustomMarketID,
    productName: window.Pattern === 2 ? selectedFoodSpec.value.Product?.Name : itemDatas.value.Name,
  });
}

function slideEnd() {
  nowSlide.value = false;
}

getMarketRecommendData();
</script>
